import { get } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { FlexColumn, FlexRow } from 'web-ui-components/lib/global/layout';
import { InformationRevealPanel } from 'web-ui-components/lib/layout/content';
import { Field } from 'web-ui-components/lib/molecules/forms';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { StandardLabel } from 'web-ui-components/lib/typography/labels';
import { getAllNotifications } from '../../../../src/states/notifications/selectors';
import { TYPE_CHAPS, TYPE_FASTER_PAYMENTS } from '../../../config';
import { CONST_FILE_UPLOAD } from '../../../config/constants';
import { trimBatchName } from '../../../helpers/fieldHelpers';
import PaymentsFileImport from '../../../sharedComponents/PaymentsFileImport';
import { getAccountUsingSearchParam } from '../../../states/accounts/actions';
import { fromAccountPropType } from '../../../states/accounts/propTypes';
import { toggleBatch, updateBatchName, updateBatchType } from '../../../states/batch/actions';
import { getBatchName } from '../../../states/batch/selectors';
import { clearImportedPaymentList, updateImportedPaymentList } from '../../../states/importedPaymentList/actions';
import { getImportedPaymentList } from '../../../states/importedPaymentList/selector';
import { getIsLCV } from '../../../states/modes/selectors';
import { addNotification, clearNotification } from '../../../states/notifications/actions';
import { goToPage, pages } from '../../../states/page/actions';
import { hasAccountInAccounts } from '../../../utils/accountUtils';
import {
	getCHAPSRules,
	getFPSRules,
	getFromAccountIds,
	getFromAccountNumbers,
	getUniqueAccounts,
} from '../../../utils/paymentsImportUtils';
import { PaymentDate } from '../Payments/Form/PaymentDate';
import { contentPropTypes } from '../Payments/payment.content';

const mapState = (state) => ({
	paymentName: getBatchName(state),
	importedPaymentList: getImportedPaymentList(state),
	notification: getAllNotifications(state),
	isLCV: getIsLCV(state),
});

const mapDispatch = (dispatch) => ({
	handleToggleIsBatch: (isBatch) => dispatch(toggleBatch(isBatch)),
	handlePaymentNameChange: (name) => dispatch(updateBatchName({ name })),
	clearImportedPaymentList: () => dispatch(clearImportedPaymentList()),
	updateBatchType: (batchType) => dispatch(updateBatchType({ batchType })),
	clearNotification: (id) => dispatch(clearNotification(id)),
	addNotification: (type, payload) => dispatch(addNotification(type, payload)),
	updateImportedPaymentList: (payments, date) => dispatch(updateImportedPaymentList(payments, date)),
	continueToImportedPayments: (page) => dispatch(goToPage(page)),
	getAccountUsingSearchParam: (accountNumber, paymentType) =>
		dispatch(getAccountUsingSearchParam(accountNumber, paymentType)),
});
class FileUploadRevealBlock extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			showUploadButton: false,
			paymentName: props.paymentName,
			date: props.firstSubmissionDate,
		};
		this.handleFileUploadButtonClick = this.handleFileUploadButtonClick.bind(this);
		this.handleChooseFileButtonClick = this.handleChooseFileButtonClick.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleLCVUploadButtonSuccess = this.handleLCVUploadButtonSuccess.bind(this);
		this.continueToNextPage = this.continueToNextPage.bind(this);
		this.handleSubReveal = this.handleSubReveal.bind(this);
	}
	componentDidMount() {
		this.props.clearImportedPaymentList();
	}
	componentWillReceiveProps(nextProps) {
		if (moment(this.state.date).isValid() && nextProps.firstSubmissionDate !== this.props.firstSubmissionDate) {
			this.setState({
				date: nextProps.firstSubmissionDate,
			});
		}
	}
	continueToNextPage() {
		const { handlePaymentNameChange, continueToImportedPayments, handleToggleIsBatch, updateBatchType, type } =
			this.props;
		const { paymentName } = this.state;

		handlePaymentNameChange(paymentName);
		updateBatchType(CONST_FILE_UPLOAD.BATCH_TYPE);
		handleToggleIsBatch(true);
		const page = type === TYPE_FASTER_PAYMENTS ? pages.ImportedFasterPaymentsPage : pages.ImportedChapsPaymentsPage;
		return continueToImportedPayments(page);
	}
	handleLCVUploadButtonSuccess(response) {
		const { updateImportedPaymentList, addNotification, importedPaymentList } = this.props;
		const { date } = this.state;

		const numberOfAccounts = response.map((response) => response.payload.total_number_of_accounts);
		const getNumberOfAccounts = numberOfAccounts.reduce((partialSum, a) => partialSum + a, 0);
		if (!getNumberOfAccounts) return addNotification('permissionError', { errorType: 'permissionError' });

		updateImportedPaymentList(importedPaymentList, date);
		return this.continueToNextPage();
	}
	handleFileUploadButtonClick() {
		const {
			getAccountUsingSearchParam,
			importedPaymentList,
			notification,
			clearNotification,
			addNotification,
			fromAccounts,
			isLCV,
		} = this.props;
		const notificationId = get(notification, '[0].id', 0);
		if (notificationId) clearNotification(notificationId);

		const fromAccountIds = getFromAccountIds(importedPaymentList);
		const fromAccountNumbers = getFromAccountNumbers(importedPaymentList);
		const uniqueFromAccountNumbers = getUniqueAccounts(fromAccountNumbers);

		if (uniqueFromAccountNumbers.length > 10) {
			return addNotification('serviceErrorDuringPaymentUpload', { errorType: 'sourceAccountLimitError' });
		}

		if (isLCV) {
			return Promise.all(uniqueFromAccountNumbers.map(getAccountUsingSearchParam)).then((responses) => {
				if (responses.some((response) => response.error)) {
					return addNotification('serviceErrorDuringPaymentUpload', { errorType: 'genericServiceError' });
				}

				return this.handleLCVUploadButtonSuccess(responses);
			});
		}

		if (
			(!isLCV && !uniqueFromAccountNumbers.length) ||
			(!isLCV && !hasAccountInAccounts(fromAccountIds, fromAccounts))
		) {
			return addNotification('permissionError', { errorType: 'permissionError' });
		}

		return this.continueToNextPage();
	}
	handleChooseFileButtonClick(importedPaymentList, paymentName, hasError) {
		const { updateImportedPaymentList } = this.props;
		const { date } = this.state;
		this.setState({
			showUploadButton: !hasError,
			paymentName: trimBatchName(paymentName),
		});
		if (!hasError) {
			updateImportedPaymentList(importedPaymentList, date);
		}
	}
	handleDateChange(date) {
		const { importedPaymentList, updateImportedPaymentList } = this.props;
		const { showUploadButton } = this.state;
		if (moment(date).isValid()) this.setState({ date });
		if (showUploadButton) updateImportedPaymentList(importedPaymentList, date);
	}

	handleSubReveal() {
		this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
	}

	render() {
		const { maxDate, content, type, faq, template, paymentDates, maxRecords } = this.props;
		if (![TYPE_FASTER_PAYMENTS, TYPE_CHAPS].includes(type)) return null;
		const { showUploadButton, date, isOpen } = this.state;
		const { isHeaderRow, rules } = type === TYPE_FASTER_PAYMENTS ? getFPSRules() : getCHAPSRules();
		const { fileImportText, instructionsURLText, templateURLText, fileUploadButtonText, paymentDateLabel } = content;
		return (
			<InformationRevealPanel titleText="Upload payment from file" isOpen={isOpen} onClick={this.handleSubReveal}>
				<StandardBody>{fileImportText.replace('{maxRecords}', maxRecords)}</StandardBody>
				<StandardBody>
					<FlexRow>
						<FlexColumn gutter={2} proportion={1} verticalAlignment="bottom">
							<Field className="u-margin-bottom-2">
								<StandardLabel>{paymentDateLabel}</StandardLabel>
								<PaymentDate
									id="field-imported-payment-date"
									date={date}
									handleDateChange={this.handleDateChange}
									title={paymentDateLabel}
									className="c-o-list-payment__row-cell c-o-list-payment__row-cell--responsive-half c-o-list-payment__row-cell--date"
									htmlFor="importedPaymentDate"
									maxDate={maxDate}
									showPopover={false}
									paymentDates={paymentDates}
								/>
							</Field>
						</FlexColumn>
						<FlexColumn proportion={2} verticalAlignment="bottom">
							<PaymentsFileImport
								handleChooseFileButtonClick={this.handleChooseFileButtonClick}
								isHeaderRow={isHeaderRow}
								rules={rules}
								type={type}
								maxRecords={maxRecords}
							/>
						</FlexColumn>
						{showUploadButton && (
							<FlexColumn proportion={1} verticalAlignment="bottom">
								<ActionButton.Upload
									onClick={this.handleFileUploadButtonClick}
									labelText={fileUploadButtonText}
									data-test-id="action-file-upload"
								/>
							</FlexColumn>
						)}
					</FlexRow>
					<StandardBody isFlush>
						<WebsiteLink url={faq} linkText={instructionsURLText} willOpenNewWindow />
					</StandardBody>
					<StandardBody isFlush>
						<WebsiteLink url={template} linkText={templateURLText} willOpenNewWindow />
					</StandardBody>
				</StandardBody>
			</InformationRevealPanel>
		);
	}
}

FileUploadRevealBlock.defaultProps = {
	paymentName: '',
	firstSubmissionDate: moment(),
};

FileUploadRevealBlock.propTypes = {
	maxDate: PropTypes.instanceOf(moment),
	content: PropTypes.shape(contentPropTypes).isRequired,
	type: PropTypes.string.isRequired,
	faq: PropTypes.string.isRequired,
	template: PropTypes.string.isRequired,
	maxRecords: PropTypes.number.isRequired,
	continueToImportedPayments: PropTypes.func.isRequired,
	handleToggleIsBatch: PropTypes.func.isRequired,
	handlePaymentNameChange: PropTypes.func.isRequired,
	clearImportedPaymentList: PropTypes.func.isRequired,
	updateImportedPaymentList: PropTypes.func.isRequired,
	importedPaymentList: PropTypes.arrayOf(PropTypes.object),
	paymentName: PropTypes.string,
	updateBatchType: PropTypes.func.isRequired,
	notification: PropTypes.arrayOf(PropTypes.string.isRequired),
	clearNotification: PropTypes.func.isRequired,
	addNotification: PropTypes.func.isRequired,
	paymentDates: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	firstSubmissionDate: PropTypes.instanceOf(moment),
	isLCV: PropTypes.bool,
	getAccountUsingSearchParam: PropTypes.func.isRequired,
};

export const connectWrapper = connect(mapState, mapDispatch)(FileUploadRevealBlock);
